import Swal from 'sweetalert2';

// Ova funkcija će biti dostupna globalno
window.showAlert = function(type, title, text) {
    Swal.fire({
        position: 'top-end',
        icon: type,
        title: `<p style="font-size:16px;">${title}</p>`,
        html: `<p style="font-size:16px;">${text}</p>`,
        showConfirmButton: false,
        timer: 5000
    });
};
